import { connect } from "react-redux";

var WritingActions = require("lib/actions/WritingActions");

var NumbersOnlyInput = require("components/utility/NumbersOnlyInput");
var CurrentUser = require("lib/account/CurrentUser");

@connect(
  (state, props) => {
    var downProps = {};
    downProps.nextQuestion = props.nextQuestion;
    downProps.evaluation = props.evaluation;
    downProps.graderID = CurrentUser.get().id
    return downProps;
  },
  (dispatch, props) => ({
    onUpdate: (evaluationID, evaluationUpdate) => {
      if (evaluationID) {
        dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: evaluationUpdate }));
      }
    },
  })
)
class AnswerEvalOverride extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    if (props.evaluation && props.evaluation.ratio) {
      var editedScore = $wr.convertedScore(props.evaluation.ratio, 4);
    }
    this.state = { editedScore };
  }

  saveEvaluation(e) {
    $wr.nope(e);

    var originalEvaluation = this.props.evaluation;

    // Round up to the nearest 0.5
    var override = Math.round(this.state.editedScore * 2) / 2;

    var adminRatio = override / this.displayScoreCap();

    // Project this onto the scale of the original evaluation
    var adminScore = Math.ceil(adminRatio * originalEvaluation.score_cap);
    
    // set to 0 or score_cap if outside of 0-score_cap range
    if (adminScore < 0) {
      adminScore = 0;
      adminRatio = 0;
    } else if (adminScore > originalEvaluation.score_cap) {
      adminScore = originalEvaluation.score_cap;
      adminRatio = 1;
    }

    var scoreDetails = _.extend({}, originalEvaluation.score_details, { admin_score: adminScore });

    // Included both score (for immediate display) and adminScore (for the API Patch)
    var updateData = {
      score: adminScore,
      ratio: adminRatio,
      admin_score: adminScore,
      score_details: scoreDetails,
      grader_id: this.props.graderID,
    };
    
    this.props.onUpdate(originalEvaluation.id, updateData);

    this.setState({ editingEvaluation: false });

    window.wrNotifications.triggerDropDownNotification({
      title: "Score Edited",
      text: "You have edited the score for this question",
      icon: "ok-sign",
    });

    // Finds the next question in the parent component
    this.props.nextQuestion();
  }

  displayScoreCap() {
    return 4;
  }

  render() {
    if (this.props.evaluation) {
      var currentScore = $wr.convertedScore(this.props.evaluation.ratio, 4);

      if (this.state.editedScore !== currentScore) {
        var saveButton = <button className="btn btn-link saveButton">Save</button>;
      }

      var editScore = (
        <form onSubmit={this.saveEvaluation} className="editRow">
          <div>
            Edit Score:{" "}
            <NumbersOnlyInput
              className="form-control scoreEdit"
              allowDecimal
              value={this.state.editedScore}
              step={0.5}
              onChange={(e) => this.setState({ editedScore: parseFloat(e.target.value) })}
              max={this.displayScoreCap()}
              min={0}
            />{" "}
            / {this.displayScoreCap()}
            {saveButton}
          </div>
        </form>
      );
    }

    return <div className="editControls">{editScore}</div>;
  }
}

AnswerEvalOverride.propTypes = StrictPropTypes({
  quizEvaluation: PropTypes.object,
  answerEvaluation: PropTypes.object,
  evaluation: PropTypes.object,
  nextQuestion: PropTypes.func,

  //From @connect
  onUpdate: PropTypes.func,
});

module.exports = AnswerEvalOverride;



// WEBPACK FOOTER //
// ./modules/components/writing/answers/AnswerEvalOverride.js